/* eslint no-multi-spaces: 0 */

import Vue            from 'vue'
import Router         from 'vue-router'
import { routerHistory, writeHistory } from 'vue-router-back-button'

import {store}        from '@/components/store'
import User           from '@/core/user'
// import Login          from '@/components/Login'
import ModulesWrapper from '@/components/ModulesWrapper'
import NotFound       from '@/components/GeneralViews/NotFound.vue'
import Logout         from '@/core/legacy-auth/logout'
import SwitchAccount  from '@/components/Login/accounts'

import {i18n} from '@/lang/lang'
const $t = (key) => i18n.t(key)

Vue.use(Router)
Vue.use(routerHistory)

const routes = [
  // {
  //   name: 'evedpay',
  //   path: '/evedpay/:tab?',
  //   component: ModulesWrapper.publicShell
  // },
  {
    name: 'evedpaycards',
    path: '/evedpay/cards',
    component: ModulesWrapper.publicShell
  },
  {
    name: 'evedpaytransactions',
    path: '/evedpay/transactions',
    component: ModulesWrapper.publicShell
  },
  {
    name: 'evedpaycardtransactions',
    path: '/evedpay/cardtransactions/:cardid?',
    component: ModulesWrapper.publicShell
  },
  {
    name: 'evedpaycarddetails',
    path: '/evedpay/details/:cardid?',
    component: ModulesWrapper.publicShell
  },
  {
    name: 'evedpaytransactiondetails',
    path: '/evedpay/transactiondetails/:transactionid?',
    component: ModulesWrapper.publicShell
  },
  {
    name: 'evedpayrequestphysicalcard',
    path: '/evedpay/requestcard',
    component: ModulesWrapper.publicShell
  },
  {
    name: 'evedpayshownumber',
    path: '/evedpay/shownumber',
    component: ModulesWrapper.publicShell
  },
  {
    name: 'evedpaychangepin',
    path: '/evedpay/changepin',
    component: ModulesWrapper.publicShell
  },
  {
    name: 'evedpayrequestaddfunds',
    path: '/evedpay/loadfunds',
    component: ModulesWrapper.publicShell
  },
  {
    name: 'login',
    path: '/login',
    component: ModulesWrapper.publicShell
  },
  {
    name: 'switchaccount',
    path: '/switch-account',
    component: SwitchAccount
  },
  {
    name: 'mfasetup',
    path: '/mfa-setup',
    component: ModulesWrapper.publicShell
  },
  {
    name: 'logout',
    path: '/logout',
    component: Logout
  },
  {
    name: 'RejectAll',
    path: '/d/reject-all',
    component: ModulesWrapper.shell
  },
  {
    name: 'ApproveAll',
    path: '/d/approve-all',
    component: ModulesWrapper.shell
  },
  {
    path: '/',
    redirect: '/home'
  },
  {
    name: 'home',
    path: '/home',
    redirect: global.config && global.config.start || '/d/Dashboard/My'
  },
  {
    name: '_allLegacy',
    path: '/l',
    component: ModulesWrapper.legacy
  },
  {
    path: '/:namespace/:page?/:section?/:action?',
    name: '_allModules',
    component: ModulesWrapper.shell,
    meta: { requiresAuth: !global.config }
  },
  { name: '404', path: '/404', component: NotFound },
  { name: 'nogo', path: '*', redirect: '404' }
]

const router = new Router({
  routes,
  checkNotSavedData,
  linkActiveClass: 'active' /*,
  scrollBehavior (to, from, savedPosition) {
    //
    try {
      document.querySelector('.main-panel').scrollTop = 0
    } catch (e) {}
  } */
})

router.beforeEach(checkAuth)
router.afterEach(writeHistory)
router.afterEach((to, from) => {
  global.Page && global.Page.showTabs && global.Page.showTabs('', '', from.query.noRedir !== '1' ? from.query.goto : null, null)
})

export default router

/**
 * Hook into routes for checking user authorization
 * before navigation else redirect to login
 * @summary Navigation guard
 */
function checkAuth (to, from, next) {
  // Check authorization and redirect to login if failed
  const user = User.get()

  // force iframe reload on only query param change
  if (from.params.namespace === 'i' && to.params.namespace === 'i') {
    if (global.document.getElementById('MainPageFrame')) {
      if (typeof to.query.switchAccount !== 'undefined' || typeof from.query.switchAccount !== 'undefined') {
        //
      } else {
        global.document.getElementById('MainPageFrame').src = global.document.getElementById('MainPageFrame').src
      }
    }

    if (global.document.getElementById('iframe') && ~to.fullPath.indexOf('?')) {
      if (typeof to.query.switchAccount !== 'undefined' || typeof from.query.switchAccount !== 'undefined') {
        //
      } else {
        global.frames['NetFrame'].location = global.app.api.env + to.fullPath.split(to.params.page)[1]
      }
    }
  }
  // suppress loading on clicking main navigation
  if (router.previousPath === to.path) {
    setTimeout(() => {
      if (global.document.getElementById('iframe')) global.document.getElementById('iframe').className = 'content'
    })
  }

  router.previousPath = from.path
  if (to.meta.requiresAuth) {
    if (!user || !user.token) {
      next({name: 'login'})
      // next({name: 'login', query: { returnUrl: to.path, noRedir: 1 }})
    } else {
      checkNotSavedData(to, from, next)
      // next()
    }
  } else {
    if (to.query.sk) {
      next()
    } else {
      if (to.query.returnUrl && user && user.token) {
        next(to.query.returnUrl)
      }
      (from.query.returnUrl || from.query.sk) && (!user || !user.token)
        ? typeof to.query.mfa !== 'undefined' ? next() : redirectToLogin(to, from, next)
        : checkNotSavedData(to, from, next)
      // next()
    }
  }
}

/**
 * Hook into routes for checking returnUrl
 * before navigation and redirect acordingly
 * @summary Navigation guard
 */
function redirectToLogin (to, from, cb) {
  if (from.query.noRedir !== '1') {
    cb()
    cb('/login?returnUrl=' + encodeURIComponent(from.query.returnUrl) + '&noRedir=1' + (typeof to.query.mfa !== 'undefined' ? '&mfa' : ''))
  } else {
    cb('/login?returnUrl=' + from.query.returnUrl + '&sk=' + from.query.sk + (typeof to.query.mfa !== 'undefined' ? '&mfa' : ''))
  }
}

/**
 * Hook into routes for checking draft data
 * before navigation and display a notification
 * @summary Navigation guard
 */
function checkNotSavedData (to, from, cb) {
  const pending = store.state.pendingData

  if (global.app.$notifications && pending) {
    global.app.$notifications.notify({
      type: 'plain',
      icon: 'exclamation-circle',
      placement: { from: 'top', align: 'center' },
      timeout: 0,

      message: (pending === true ? `` : `${$t('You have unsaved data')} <br />`) +
                `${$t('Are you sure you want to navigate away ?')}`,

      dismiss: $t('Yes'),
      target: '_blank',
      goto: `#${to ? to.path : ''}`,

      onClose: function (dismiss) {
        if (dismiss) {
          store.state.pendingData = null
        } else if (dismiss === '') {
          global.localStorage.setItem('evedDraftData', JSON.stringify(store.state.pendingData))
          store.state.pendingData = null
        }
      }
    })
    cb && cb(false)
  } else {
    cb && cb()
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js